import ContentCopyOutlined from '@mui/icons-material/ContentCopyOutlined';
import { Box } from '@mui/material';
import {
  MemoStatefulAutocompleteWithText,
  MemoStatefulSingleSelect,
} from 'components/dataCreationForms/withInputForm/statefulInputsWrapper';
import { ButtonTextIcon } from 'components/general';
import { FormattedMessage } from 'intl';
import React from 'react';
import { CompanyFormSection } from '../section';
import { CompanyAddressFieldsProps } from '../types';

export function CompanyAddressSectionPresentational({
  copySource,
  titleId,
  textFieldsProps,
  countryFieldProps,
  isDialog,
  fieldsVersion,
  canCopy,
  onCopy,
}: CompanyAddressFieldsProps & {
  isDialog: boolean;
  fieldsVersion: number;
  canCopy: boolean;
  onCopy: () => void;
}): React.ReactElement {
  return (
    <CompanyFormSection
      titleId={titleId}
      isDialog={isDialog}
      titleAction={
        copySource && (
          <ButtonTextIcon
            startIcon={ContentCopyOutlined}
            disabled={!canCopy}
            onClick={onCopy}
            data-qa='company_copy_address_button'
          >
            <FormattedMessage id={copySource.labelId} />
          </ButtonTextIcon>
        )
      }
    >
      {textFieldsProps.map((fieldProps) => (
        <Box key={`${String(fieldProps.formKey)}-${fieldsVersion}`}>
          <MemoStatefulAutocompleteWithText {...fieldProps} />
        </Box>
      ))}
      <Box key={`${String(countryFieldProps.formKey)}-${fieldsVersion}`}>
        <MemoStatefulSingleSelect {...countryFieldProps} />
      </Box>
    </CompanyFormSection>
  );
}
